import { useSuspenseQuery } from "@tanstack/react-query";
import { getSocialLinks } from "@/app/api/essentials.route";

export const useSocialLinks = () => {
  const queryKey = ["socialLinks"];

  const _getSocialLinks = useSuspenseQuery({
    queryKey,
    queryFn: async () => {
      return await getSocialLinks();
    },
  });

  return _getSocialLinks;
};
